import { Component, OnInit } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { NcalayerService } from '../@core/utils/ncalayer/ncalayer.service';
import Swal from 'sweetalert2';
import { Result } from '../@core/data/result';
import { RestService } from '../@core/utils/rest.service';

@Component({
  selector: 'ngx-jur',
  template: `
    <ngx-sample-layout (mouseover)="mouseover($event)">
    
       <nb-menu [items]="menu"></nb-menu>
   
    <router-outlet></router-outlet>
  </ngx-sample-layout>
  `,
  styleUrls: ['./jur.component.scss']
})

export class JurComponent implements OnInit {  
  menu:any;
  objectLang: any;
  count:number=0;
  countPrev: number=0;
  timer:String='';
  event:any;
  address: any;
  KBE: any;
  Persons: any;
  constructor(
    public ncalayer: NcalayerService,
    public translate: TranslateService,
    public rest:RestService,
    private router: Router,
    private menuS: NbMenuService,
  ) {
    menuS.onItemClick().subscribe((e) => {
  
      if (e.item.link == "/jur/payment"){
        
        // let KBE= sessionStorage.getItem('KBE');
        // let address= sessionStorage.getItem('address');
          if (sessionStorage.getItem('KBE')== null || sessionStorage.getItem('KBE')== undefined){
            Swal.fire({
              text: 'Необходимо заполнить КОД юридического лица',
              type: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
              });
              this.router.navigate(['/jur/main']);  
          }
          if (sessionStorage.getItem('address')=="" || sessionStorage.getItem('address')==undefined){
            Swal.fire({
              text: this.translate.instant('NOTADDRESS'),
              type: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
              });
              this.router.navigate(['/jur/main']);  
          }
          if (sessionStorage.getItem('address')=="" && sessionStorage.getItem('KBE')== null){
            Swal.fire({
              text: 'Необходимо заполнить адрес организации и КОД',
              type: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
              });
              this.router.navigate(['/jur/main']);  
          }
          if (JSON.parse(sessionStorage.getItem('persons')).lenght<1){
            Swal.fire({
              text: 'Необходимо заполнить список сотрудников',
              type: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
              });
              this.router.navigate(['/jur/employee']);  
          }
      }
    console.log(e);
    });
  }  
  translateLang(){
    this.translate.get(['MAIN', 'REQUISITES', 'LIST','PAYMENTS','FORMPAY','STRORIESPAY','ALERTNOSERVICE','ALERTSESIIONEND', 'KASPI_QR']).subscribe(translations => {
      this.objectLang=translations;
   
    let MENU_ITEMS: NbMenuItem[] = [
      {
          title: this.objectLang.MAIN,
          icon: 'nb-home',
          link: '/jur/cabinet',
          home: true,
        },
        {
          title: this.objectLang.REQUISITES,
          icon: 'nb-keypad',
          link: '/jur/main',
     
        },
        {
          title: this.objectLang.LIST,
          icon: 'nb-person',
          link: '/jur/employee',
     
        },
      {
        title: this.objectLang.PAYMENTS,
        icon: 'nb-compose',
        children: [
          {
            title: this.objectLang.KASPI_QR,
            icon: 'nb-grid-a',
            link: '/jur/payment-kaspi',
         
          },
          {
            title: this.objectLang.FORMPAY,
            icon: 'nb-checkmark-circle',
            link: '/jur/payment',
         
          },
          {
            title: this.objectLang.STRORIESPAY,
            icon:'ion-folder',
            link: '/jur/paystories',
          },
        ],
      },
     
    ];
    this.menu = MENU_ITEMS;
    
  });
  }
 
  ngOnInit() { 
    try{
      this.translateLang();
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.translate.use(event.lang);
        this.translateLang();
      });
      
    }
    catch (e){
      Swal.fire({
        text: 'Сервис временно не доступен',
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
        })
      }
      }
      public mouseover(e:any){
            
           this.count=e.clientX; 
      }
  checkPayment(){
    Swal.fire({
      text: 'f off',
      type: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: "#008e54"
    })
    let str= '/jur/employee';
    return str;
  }
}





